import { createAction, props } from '@ngrx/store';
import { Delegation, DelegationAddEdit } from 'src/app/delegations/models/delegation';
import { DelegationUser } from 'src/app/delegations/models/delegation-user';

export const createDelegation = createAction(
    '[DELEGATIONS LIST COMPONENT] Create Delegation',
    props<{ delegation: DelegationAddEdit }>()
);
export const createDelegationSuccess = createAction(
    '[DELEGATIONS API] Create Delegation Success',
    props<{ ownerId: string; message: string }>()
);
export const createDelegationFailure = createAction(
    '[DELEGATIONS API] Create Delegation Failure',
    props<{ error: string }>()
);

export const updateDelegation = createAction(
    '[DELEGATIONS LIST COMPONENT] Update Delegation',
    props<{ delegation: DelegationAddEdit }>()
);
export const updateDelegationSuccess = createAction(
    '[DELEGATIONS API] Update Delegation Success',
    props<{ ownerId: string; message: string }>()
);
export const updateDelegationFailure = createAction(
    '[DELEGATIONS API] Update Delegation Failure',
    props<{ error: string }>()
);

export const clearDelegationEmployees = createAction('[DELEGATIONS ADD EDIT DIALOG COMPONENT] Clear Employees');
export const searchDelegationEmployees = createAction(
    '[DELEGATIONS ADD EDIT DIALOG COMPONENT] Search Employees',
    props<{ query: string }>()
);
export const searchDelegationEmployeesSuccess = createAction(
    '[DELEGATIONS SEARCH EMPLOYEES API] Search Employees Success',
    props<{ delegationEmployees: DelegationUser[] }>()
);
export const searchDelegationEmployeesFailure = createAction(
    '[DELEGATIONS SEARCH EMPLOYEES API] Search Employees Failure',
    props<{ error: unknown }>()
);

export const clearAssignedToMeDelegations = createAction(
    '[DELEGATIONS LIST COMPONENT] Clear Assigned To Me Delegations'
);

export const getAssignedToMeDelegations = createAction(
    '[DELEGATIONS LIST COMPONENT] Get Assigned To Me Delegations',
    props<{ delegateeId: string }>()
);
export const getAssignedToMeDelegationsSuccess = createAction(
    '[DELEGATIONS API] Get Assigned To Me Delegations Success',
    props<{ delegations: Delegation[] }>()
);
export const getAssignedToMeDelegationsFailure = createAction(
    '[DELEGATIONS API] Get Assigned To Me Delegations Failure',
    props<{ error: string }>()
);

export const clearOwnerDelegations = createAction('[DELEGATIONS LIST COMPONENT] Clear Owner Delegations');

export const getOwnerDelegations = createAction(
    '[DELEGATIONS LIST COMPONENT] Get Owner Delegations',
    props<{ ownerId: string }>()
);
export const getOwnerDelegationsSuccess = createAction(
    '[DELEGATIONS API] Get Owner Delegations Success',
    props<{ delegations: Delegation[] }>()
);
export const getOwnerDelegationsFailure = createAction(
    '[DELEGATIONS API] Get Owner Delegations Failure',
    props<{ error: string }>()
);

export const setDelegationToInactive = createAction(
    '[DELEGATIONS LIST COMPONENT] Set Delegation To Inactive',
    props<{ delegation: Delegation }>()
);
export const setDelegationToInactiveSuccess = createAction(
    '[DELEGATIONS API] Set Delegation To Inactive Success',
    props<{ ownerId: string; message: string }>()
);
export const setDelegationToInactiveFailure = createAction(
    '[DELEGATIONS API] Set Delegation To Inactive Failure',
    props<{ error: string }>()
);
